import React from 'react';
import CartContextProvider from './CartContext';
import CartBody from './CartBody';
import { CartData } from '@interfaces/cart';

const Cart: React.FC<{ data: CartData }> = ({ data }) => {
  return (
    <CartContextProvider data={data}>
      <CartBody />
    </CartContextProvider>
  );
};

export default Cart;
